import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithPopup,
  OAuthProvider,
  AuthProvider,
  GoogleAuthProvider,
} from '@firebase/auth';
import { useConfig } from './useUtils';

export default function useFirebaseAuth() {
  // Firebaseの初期化
  // 環境変数からFirebaseの設定を取得する
  const config = useConfig();
  const fbConfig = config.FIREBASE_CONFIG;
  const firebaseConfig = {
    apiKey: fbConfig.apiKey,
    authDomain: fbConfig.authDomain,
    projectId: fbConfig.projectId,
    storageBucket: fbConfig.storageBucket,
    messagingSenderId: fbConfig.messagingSenderId,
    appId: fbConfig.appId,
  };

  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);

  const showPopup = async (provider: AuthProvider) => {
    const result = await signInWithPopup(auth, provider);
    return await result.user?.getIdToken(true);
  };

  return {
    signInMicrosoft: () => showPopup(new OAuthProvider('microsoft.com')),
    signInApple: () => showPopup(new OAuthProvider('apple.com')),
    signInGoogle: () => showPopup(new GoogleAuthProvider()),
  };
}
